import React from 'react';
import { useHistory } from 'react-router-dom';
import { Close } from '@material-ui/icons';
import moment from 'moment';
import axios from 'axios';
import { useAuth } from '../../../context/auth';
import {
    Wrapper,
    FlexWrapper,
    Date,
    CampaignTitle,
    NotificationInfo,
    StyledIconButton,
    Redirect
} from './NotificationCard.styles'
import { NotificationCardProps } from './NotificationCard.interface';

export function NotificationCard({ data, refresh, closePopper }: NotificationCardProps ) {
    const { authToken } = useAuth();
    const history = useHistory();
    const markAsRead = () => {
        axios.patch(`${process.env.REACT_APP_BASE_URL}/api/notifications/notification/${data.id}/mark-as-read/`,{}, {headers: { DTOKEN: `${authToken}`}}).then(() => {
            refresh();
        })
    }
    const redirect = (path: string) => {
        markAsRead();
        closePopper();
        if (path) {
            history.push(path);
        }
    }
    const date = moment(data.createAt).format('DD MMM YYYY');
    const type = 'Campaign almost finished!';
    return (
        <Wrapper isRead={data.isRead}>
            <FlexWrapper>
                <Date>{date}</Date>
                <StyledIconButton onClick={markAsRead}>
                    <Close />
                </StyledIconButton>
            </FlexWrapper>
            <Redirect onClick={() => redirect(data.notificationUrl)}>
                <NotificationInfo>{data.notificationType}</NotificationInfo>
                <CampaignTitle>{data.campaignTitle}</CampaignTitle>
                {type === data.notificationType &&
                    <NotificationInfo>Progress: {data.additionalInformation.progress}</NotificationInfo>
                }
            </Redirect>
        </Wrapper>
    )
}
